// Hide Klaviyo Newsletter Popup under certain conditions
document.addEventListener("DOMContentLoaded", function () {
  let klaviyoID;
  let isObserving = false;
  let isClosingPopup = false;
  let timeout;

  // Hide Klaviyo popup forms whenever they appear
  let closeDebounce = null;
  const observer = new MutationObserver(function () {
    if (closeDebounce) return;
    closeDebounce = setTimeout(() => {
      const popup = document.querySelector('[data-testid="FULLSCREEN"]');
      if (popup) {
        const overlay = popup.closest('[role="dialog"]');
        if (overlay) {
          const form = popup.querySelector("form");
          klaviyoID = form?.dataset?.testid?.replace("klaviyo-form-", "");
          const closeBtn = document.querySelector('[aria-label="Close dialog"]');
          if (closeBtn) {
            closeBtn.dispatchEvent(new MouseEvent("click", { bubbles: false, cancelable: true }));
          }
        }
      }
      closeDebounce = null;
    }, 150);
  });

  const suppressKlaviyoPopup = () => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    if (isObserving) return;
    isObserving = true;

    // add styles to hide the popup immediately when it appears
    if (!document.getElementById("klaviyo-popup-hide-style")) {
      const style = document.createElement("style");
      style.id = "klaviyo-popup-hide-style";
      style.innerHTML = `
      [aria-label="FULLSCREEN Form"]  {
        opacity: 0 !important;
        pointer-events: none !important;
      }
    `;
      document.head.appendChild(style);
    }

    observer.observe(document.body, { childList: true, subtree: true });
  };

  // Show popup once user responds to cookie banner
  function popupClosed() {
    if (isClosingPopup) return;
    isClosingPopup = true;
    isObserving = false;
    observer.disconnect();

    // remove the style that hides the popup
    const existingStyle = document.querySelector("#klaviyo-popup-hide-style");
    if (existingStyle) {
      existingStyle.remove();
    }

    // Remove form entry from localStorage to ensure the popup can show again
    const klaviyoOnsite = localStorage.getItem("klaviyoOnsite");
    if (klaviyoOnsite && klaviyoID) {
      try {
        const parsed = JSON.parse(klaviyoOnsite);
        // only remove the klaviyo id from disabledForms and viewedForms
        if (parsed.viewedForms?.modal?.disabledForms?.[klaviyoID]) {
          delete parsed.viewedForms.modal.disabledForms[klaviyoID];
        }
        if (parsed.viewedForms?.modal?.viewedForms?.[klaviyoID]) {
          delete parsed.viewedForms.modal.viewedForms[klaviyoID];
        }
        localStorage.setItem("klaviyoOnsite", JSON.stringify(parsed));
      } catch (error) {
        console.error("Failed to parse klaviyoOnsite data");
      }
    }

    const copyOfKlaviyoID = klaviyoID;
    klaviyoID = null;

    // manually trigger the popup after a short delay
    timeout = setTimeout(() => {
      if (copyOfKlaviyoID) {
        window.klaviyo && window.klaviyo.openForm(copyOfKlaviyoID);
      }
    }, 5000);

    isClosingPopup = false;
  }

  // cookiebot events
  window.addEventListener("CookiebotOnDialogDisplay", suppressKlaviyoPopup);
  window.addEventListener("CookiebotOnAccept", popupClosed);
  window.addEventListener("CookiebotOnDecline", popupClosed);

  // candyrack events
  document.addEventListener("candyrack-closed", popupClosed);
  setInterval(() => {
    if (isObserving) return;
    window.CandyRack?.popupOpen && suppressKlaviyoPopup();
  }, 50);
});

/* Activate Mobile Checkout Banner using Cart Attributes and Checkout Blocks App */
function setKollagenBenefitOnMobile() {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        show_kollagen_benefit_on_mobile: 'true',
      },
    }),
  })
    .then(response => response.json())
    .then(data => {
      console.log('Cart attribute updated: ', data);
    })
    .catch(error => {
      console.error('Error updating cart attribute: ', error);
    });
}

setKollagenBenefitOnMobile();
/* Activate Mobile Checkout Banner using Cart Attributes and Checkout Blocks App */


/* AB Test Cart Drawer Upsell, nun relevant für nh-cart-drawer-upsell / nh-cart-drawer-upsell-v2-swiper */
  (function () {
    if (window.__abxCartUpsellBound) return;
    window.__abxCartUpsellBound = true;

    function initCartUpsellSwipers(root) {
      if (typeof window.Swiper === 'undefined') return;

      var scope = root || document;
      var swipers = scope.querySelectorAll('[data-cart-upsell-swiper]');

      swipers.forEach(function (swiperEl) {
        if (swiperEl.swiper || swiperEl.dataset.cartUpsellSwiperInitialized === 'true') return;

        swiperEl.dataset.cartUpsellSwiperInitialized = 'true';
        new window.Swiper(swiperEl, {
          slidesPerView: 1.15,
          spaceBetween: 8,
          watchOverflow: true,
          scrollbar: {
            el: swiperEl.querySelector('.swiper-scrollbar'),
            draggable: true,
          },
          breakpoints: {
            480: {
              slidesPerView: 1.35,
            },
          },
        });
      });
    }

    initCartUpsellSwipers();

    document.addEventListener('click', async function (event) {
      var trigger = event.target.closest('[data-cart-upsell-add]');
      if (!trigger) return;

      event.preventDefault();

      if (trigger.disabled) return;

      var variantId = trigger.getAttribute('data-variant-id');
      if (!variantId) return;

      var card = trigger.closest('[data-cart-upsell-card]');
      if (card && card.classList.contains('is-loading')) return;

      if (card) {
        card.classList.add('is-loading');
      }
      trigger.setAttribute('aria-busy', 'true');
      trigger.disabled = true;

      try {
        var addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
          }),
        });

        if (!addResponse.ok) {
          throw new Error('Cart add failed');
        }

        var lastAddResponse = await addResponse.json();
        var cartResponse = await fetch('/cart.js', {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
          cache: 'no-store',
          credentials: 'same-origin',
        });

        if (!cartResponse.ok) {
          throw new Error('Cart refresh failed');
        }

        var cart = await cartResponse.json();

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              cart: cart,
              lastAddResponse: lastAddResponse,
            },
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:open', {
            bubbles: true,
          })
        );
      } catch (error) {
        console.error('Fehler beim Hinzufuegen des Upsell-Produkts:', error);
      } finally {
        if (card) {
          card.classList.remove('is-loading');
        }
        trigger.setAttribute('aria-busy', 'false');
        trigger.disabled = false;
      }
    });
  })();
/* AB Test Cart Drawer Upsell */

document.addEventListener('DOMContentLoaded', function () {
  // Check for campaign_code first — it should always override existing tracking
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("campaign_code");

  if (code && code.trim().length) {
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ discount: "" }),
    }).then(() => {
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ discount: code }),
      }).then(async () => {
        const cartResponse = await fetch("/cart.js");
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
      });
    });
  }
});


/* AB Test | CP | UTM basierte Ausspielung von Influencer Codes */
window.addEventListener('uppromote:loaded', function(event) {
  var key = 'sb2026_active_affiliates';
  var couponKey = 'sb2026_coupon';
  var affiliateKey = 'sb2026_affiliate_id';

  var activeClass = 'sb2026-active';

  function setBannerCode(code) {
    document.querySelectorAll('[data-sb2026-code]').forEach(function(el) {
      el.textContent = code || '';
    });
  }

  function applyDiscountCode(code) {
    if (!code) return Promise.resolve();

    return fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'include' })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        var codes = [];

        if (Array.isArray(cart.discount_codes)) {
          cart.discount_codes.forEach(function(discount) {
            if (discount && discount.code) codes.push(discount.code);
          });
        }

        var codeExists = codes.some(function(existingCode) {
          return existingCode.toLowerCase() === code.toLowerCase();
        });

        if (codeExists) return;

        codes.push(code);

        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ discount: codes.join(',') })
        })
          .then(function(response) {
            return response.json();
          })
          .then(function(updatedCart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));

            if (window.theme && Array.isArray(window.theme.cartUpdateCallbacks)) {
              window.theme.cartUpdateCallbacks.forEach(function(callback) {
                callback(updatedCart);
              });
            }
          });
      })
      .catch(function() {});
  }

  function getAppliedDiscountCode(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return null;

    var discount = cart.discount_codes.find(function(item) {
      return item.code && item.applicable !== false;
    });

    return discount ? discount.code.toUpperCase() : null;
  }

  function clearSb2026() {
    document.documentElement.classList.remove(activeClass);

    try {
      localStorage.removeItem(key);
      localStorage.removeItem(couponKey);
    } catch(e) {}
  }

  function syncSb2026WithCart(cart) {
    var discountCode = getAppliedDiscountCode(cart);

    if (discountCode) {
      setBannerCode(discountCode);
      activateSb2026();

      try {
        localStorage.setItem(couponKey, discountCode);
      } catch(e) {}

      return;
    }

    if (cart.item_count === 0) return;

    if (document.documentElement.classList.contains(activeClass)) {
      clearSb2026();
    }
  }

  document.addEventListener('uppromote:coupon-detected', function(event) {
    var detail = event.detail || {};
    if (!detail.coupon || !detail.affiliateId) return;

    setBannerCode(detail.coupon);

    try {
      localStorage.setItem(affiliateKey, detail.affiliateId);
      localStorage.setItem(couponKey, detail.coupon);
    } catch(e) {}

    activateSb2026();
  });

  function activateSb2026() {
    document.documentElement.classList.add(activeClass);

    try {
      var activeAffiliateId = localStorage.getItem(affiliateKey) || 'default';
      var activeAffiliates = {};

      try {
        activeAffiliates = JSON.parse(localStorage.getItem(key) || '{}');
      } catch(e) {}

      activeAffiliates[activeAffiliateId] = true;
      localStorage.setItem(key, JSON.stringify(activeAffiliates));
    } catch(e) {}
  }

  try {
    var savedCoupon = localStorage.getItem(couponKey);

    setBannerCode(savedCoupon);

    var currentAffiliateId = localStorage.getItem(affiliateKey) || 'default';
    var activeAffiliates = {};

    try {
      activeAffiliates = JSON.parse(localStorage.getItem(key) || '{}');
    } catch(e) {}

    if (activeAffiliates[currentAffiliateId]) {
      document.documentElement.classList.add(activeClass);
    }
  } catch(e) {}

  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail && event.detail.cart;

    if (cart) {
      syncSb2026WithCart(cart);
      return;
    }

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(syncSb2026WithCart)
      .catch(function() {});
  });

  document.addEventListener('click', function(event) {
    var banner = event.target.closest('.sb2026-banner');
    if (!banner) return;

    var codeEl = banner.querySelector('[data-sb2026-code]');
    if (!codeEl || codeEl.dataset.sb2026Copying) return;

    var code = codeEl.textContent.trim();
    if (!code || !navigator.clipboard || !navigator.clipboard.writeText) return;

    applyDiscountCode(code);

    navigator.clipboard.writeText(code).then(function() {
      codeEl.dataset.sb2026Copying = 'true';
      var originalText = codeEl.textContent;
      codeEl.textContent = 'Kopiert!';

      setTimeout(function() {
        codeEl.textContent = originalText;
        delete codeEl.dataset.sb2026Copying;
      }, 2000);
    }).catch(function() {});
  });
});
/* AB Test | CP | UTM basierte Ausspielung von Influencer Codes */
